import { useQuery } from "@tanstack/react-query";
import { fetchBrandMembers, settingsKeys } from "./settings-api";

/** ป้ายจำนวนผู้เข้าถึงบนหัวการ์ด section — รูปแบบเดียวกับป้ายจำนวนแคมเปญ */
export function useMemberCountLabel(brandId: string, enabled: boolean): string {
  const { data } = useQuery({
    queryKey: settingsKeys.brandMembers(brandId),
    queryFn: () => fetchBrandMembers(brandId),
    enabled,
    retry: false,
  });
  if (!enabled) return "เปิด My Job ก่อน";
  if (!data) return "…";
  // ยังไม่กำหนดใคร = ผู้ใช้ที่ถูกจำกัดสิทธิ์ยังไม่เห็นแบรนด์นี้ — บอกให้รู้ตั้งแต่หน้ารวม
  return data.length ? `${data.length} คน` : "ยังไม่กำหนด";
}
